import React, { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem("accessToken"));

    useEffect(() => {
        const checkTokenExpiration = () => {
            const token = localStorage.getItem("accessToken");

            if (!token || token === "undefined") { // Ensure token is valid
                return;
            }

            try {
                const decoded = jwtDecode(token);
                const currentTime = Date.now() / 1000;

                if (decoded.exp < currentTime) {
                    alert("Session expired. Please log in again.");
                    localStorage.removeItem("accessToken");
                    setIsAuthenticated(false);
                    navigate("/login");
                }
            } catch (error) {
                console.error("Invalid token, removing from storage.");
                localStorage.removeItem("accessToken");
                setIsAuthenticated(false);
                navigate("/login");
            }
        };

        checkTokenExpiration(); // Run immediately
        const interval = setInterval(checkTokenExpiration, 5000); // Check every 5 seconds

        return () => clearInterval(interval);
    }, [navigate]);

    return <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated }}>{children}</AuthContext.Provider>;
};
